import React from "react";

export default function Spinner() {
  return (
    <div className="loader">
      <div className="face">
        <div className="circle"></div>
      </div>
      <div className="face">
        <div className="circle"></div>
      </div>
    </div>
  );
}
